var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { checkLogin } from '../../../common/decorators';
import { ICollectState } from '../../store/CollectState';
import { Component, VueType } from '../core';
import './collect.style.scss';
import CollectList from './CollectList';
import CollectTab from './CollectTab';
let Collect = class Collect extends VueType {
    created() {
        this.state.initData();
    }
    mounted() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        $(this.$el).on('click', '[data-del]', function () {
            const $el = $(this);
            const attentKey = String($el.data('del'));
            if (attentKey) {
                self.state.delFollow(attentKey);
            }
            return false;
        });
    }
    render() {
        return <div>
            <CollectTab></CollectTab>

            <CollectList></CollectList>

        </div>;
    }
};
__decorate([
    ICollectState
], Collect.prototype, "state", void 0);
__decorate([
    checkLogin
], Collect.prototype, "created", null);
Collect = __decorate([
    Component
], Collect);
export default Collect;
